module.exports = __webpack_public_path__ + "b2ca6da3d298224427f623043d065e47.png";